var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conditions"},[(!_vm.showOnboardingMessage)?_c('div',{staticClass:"elements"},[_c('cardConditions',{attrs:{"item":_vm.conditions,"title":"Gewünschte Tätigkeit","userType":"candidate"}})],1):_c('StartOnboardingCard',_vm._g({},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }